import { render, staticRenderFns } from "./PeopleDetail.vue?vue&type=template&id=844dfb62&lang=pug"
import script from "./PeopleDetail.vue?vue&type=script&lang=js"
export * from "./PeopleDetail.vue?vue&type=script&lang=js"
import style0 from "./PeopleDetail.vue?vue&type=style&index=0&id=844dfb62&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports